import { render } from "./EmployeeWithdrawnRequests.vue?vue&type=template&id=bc973348"
import script from "./EmployeeWithdrawnRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeWithdrawnRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__